import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Grid, makeStyles, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import { useStores } from '../../hooks/use-stores';

import { loc } from '../../lib/loc';
import { ProfileLoc } from '../../loc/profile';

import Loader from '../../components/Loader';
import NotificationModal from '../../components/NotificationModal';
import EditModal from '../../components/ProfileData/EditModal';
import EditContactData from '../../components/ProfileData/EditContactData';
import EditCompanyData from '../../components/ProfileData/EditCompanyData';
import EditPhone from '../../components/ProfileData/EditPhone';
import Review from '../../components/ProfileData/Review';
import PageSubTitle from '../../components/UI/PageSubTitle';

const ProfileData = observer(() => {
    const classes = useStyles();
    const theme = useTheme();
    const isMD = useMediaQuery(theme.breakpoints.down('md'));
    const { ProfileDataStore: store } = useStores();
    const {
        profile,
        showModal,
        loading,
        showCompanyEdit,
        showUserEdit,
        showPhoneEdit,
        showEditModal,
        closeEditModal,
        hideModal,
        showReview,
        hideReview,
        showReviewModal,
        showReviewResponseModal,
        hideReviewResponseModal,
    } = store || {};
    const { email, phone, fio, company, type, city: privateCity } = profile || {};
    const { address, city, inn, title } = company || {};

    useEffect(() => {
        store.getProfile();
    }, [store]);

    if (loading) return <Loader />;

    return (
        <>
            <div className="default-title-block mb-25">Контактные данные</div>
            <div className="info-company mb-60">
                <div className="info-company__wrap-elements">
                    <NotificationModal open={showModal} onClose={hideModal} message={loc(ProfileLoc.modalMessage)} />
                    <NotificationModal open={showReviewResponseModal} onClose={hideReviewResponseModal} message="Спасибо за ваш отзыв" />

                    {company && (
                        <>
                            <Label id="companyName" name="Название компании" value={title} onClick={showEditModal} />
                            <Label id="inn" name="ИНН" value={inn} onClick={showEditModal} />
                            <Label id="city" name="Город" value={city} onClick={showEditModal} />
                            <Label id="legalAddress" name="Юр.адрес компании" value={address} onClick={showEditModal} />
                        </>
                    )}
                    <Label id="fio" name="Контактное лицо ФИО" value={fio} onClick={showEditModal} />
                    <Label id="phone" name="Номер телефона*" value={phone} onClick={showEditModal} />
                    <Label id="email" name="Почта*" value={email} onClick={showEditModal} />
                    {type === 'private' && !!privateCity && <Label id="privateCity" name="Город" value={privateCity} />}
                </div>

                <Box display="flex" width="100%" justifyContent="space-between" flexWrap="wrap">
                    <EditModal open={showUserEdit} onClose={closeEditModal}>
                        <EditContactData />
                    </EditModal>
                    <EditModal open={showCompanyEdit} onClose={closeEditModal}>
                        <EditCompanyData />
                    </EditModal>
                    <EditModal open={showPhoneEdit} onClose={closeEditModal}>
                        <EditPhone />
                    </EditModal>
                    <EditModal open={showReviewModal} onClose={hideReview}>
                        <Review />
                    </EditModal>
                </Box>
            </div>

            <Grid container spacing={isMD ? 3 : 5}>
                <Grid item xs={12} md={6}>
                    <Box className={classes.card}>
                        <Box flex={1}>
                            <PageSubTitle>Оставить отзыв</PageSubTitle>
                        </Box>
                        <Box mb={3}>
                            <Typography variant="body2">
                                Вас не устраивает сервис? Кто-то допустил ошибку при выполнении задачи? Или, наоборот, вам очень хочется
                                кого-то похвалить? Напишите нам!
                            </Typography>
                        </Box>
                        <Button variant="outlined" color="primary" onClick={showReview}>
                            Оставить отзыв
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            {/*<div className="default-title-block mb-25">Настройка рассылок</div>*/}
            {/*<div className="setting-subscriber mb-60">*/}
            {/*    <div className="setting-subscriber__wrap-items">*/}
            {/*        <div className="setting-subscriber__title">Получать сообщения на почту:</div>*/}
            {/*        <div className="setting-subscriber__wrap-checkboxs">*/}
            {/*            <label className="setting-subscriber__item-checkbox">*/}
            {/*                <input className="setting-subscriber__checkbox" type="checkbox" />*/}
            {/*                <span className="setting-subscriber__check" />*/}
            {/*                <span>Новости Arlift</span>*/}
            {/*            </label>*/}
            {/*            <label className="setting-subscriber__item-checkbox">*/}
            {/*                <input className="setting-subscriber__checkbox" type="checkbox" />*/}
            {/*                <span className="setting-subscriber__check" />*/}
            {/*                <span>Акции и новинки</span>*/}
            {/*            </label>*/}
            {/*            <label className="setting-subscriber__item-checkbox">*/}
            {/*                <input className="setting-subscriber__checkbox" type="checkbox" />*/}
            {/*                <span className="setting-subscriber__check" />*/}
            {/*                <span>Изменения статуса заказа</span>*/}
            {/*            </label>*/}
            {/*        </div>*/}
            {/*      */}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className="default-title-block mb-25">Сброс пароля</div>*/}
            {/*<ResetPassword />*/}
        </>
    );
});

export default ProfileData;

const useStyles = makeStyles(theme => ({
    icon: {
        position: 'absolute',
        top: '52%',
        right: '10px',
        cursor: 'pointer',
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        padding: theme.spacing(5),
        border: '1px solid #ececec',
    },
}));

function Label({ id, name, value, onClick }) {
    const classes = useStyles();
    return (
        <div className="info-company__wrap-input info-company__wrap-input--w50">
            <label className="info-company__label">{name}</label>
            <input className="info-company__input" value={value} type="text" disabled />
            {onClick && <EditIcon className={classes.icon} onClick={() => onClick(id)} />}
        </div>
    );
}
